<template>
  <div v-if="deliveryNote" class="main-content delivery-note-view-page">
    <div class="page-header">
      <h3 class="page-title"> {{ deliveryNote.delivery_note_number }}</h3>
      <div class="page-actions row">
        <v-dropdown :close-on-select="false" align="left" class="filter-container" v-if="deliveryNote.status=='DRAFT' && userType=='anchor'">
          <a slot="activator" href="#">
            <base-button color="theme">
              <font-awesome-icon icon="ellipsis-h" />
            </base-button>
          </a>
        </v-dropdown>
      </div>
    </div>
    <div class="delivery-note-sidebar">
      <base-loader v-if="isSearching" />
      <div v-else class="side-header">
        <base-input
          v-model="searchData.searchText"
          :placeholder="$t('general.search')"
          input-class="delNote-search"
          icon="search"
          type="text"
          align-icon="right"
          @input="onSearched()"
        />
        <div
          class="btn-group ml-3"
          role="group"
          aria-label="First group"
        >
          <v-dropdown :close-on-select="false" align="left" class="filter-container">
            <a slot="activator" href="#">
              <base-button class="delNote-button delNote-filter-fields-btn" color="default" size="medium">
                <font-awesome-icon icon="filter" />
              </base-button>
            </a>
            <div class="filter-title">
              {{ $t('general.sort_by') }}
            </div>
            <div class="filter-items">
              <input
                id="filter_delivery_note_date"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="delNote-radio"
                value="delivery_note_date"
                @change="onSearched"
              >
              <label class="delNote-label" for="filter_delivery_note_date">{{ $t('deliveryNotes.delivery_note_date') }}</label>
            </div>

            <div class="filter-items">
              <input
                id="filter_delivery_note_number"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="delNote-radio"
                value="delivery_note_number"
                @change="onSearched"
              >
              <label class="delNote-label" for="filter_delivery_note_number">{{ $t('deliveryNotes.delivery_note_number') }}</label>
            </div>
          </v-dropdown>
          <base-button v-tooltip.top-center="{ content: getOrderName }" class="delNote-button delNote-filter-sorting-btn" color="default" size="medium" @click="sortData">
            <font-awesome-icon v-if="getOrderBy" icon="sort-amount-up" />
            <font-awesome-icon v-else icon="sort-amount-down" />
          </base-button>
        </div>
      </div>
      <div class="side-content">
        <a
          v-for="(deliveryNote,index) in deliveryNotes"
          :key="index"
          class="side-delivery-note"
          href="#/"
          @click="viewDeliveryNote(deliveryNote.id)"
        >
          <div class="left">
            <div class="delNote-name" v-if="deliveryNote.buyer_stakeholder">
              <p>
                <span  v-if="deliveryNote.buyer_stakeholder.details.company && deliveryNote.buyer_stakeholder.details.company.name">
                  {{ deliveryNote.buyer_stakeholder.details.company.name }}
                </span>
                <!-- {{ deliveryNote.buyer_stakeholder.details.user.name }} -->
              </p>
            </div>
            <div class="delNote-number">{{ deliveryNote.delivery_note_number }}</div>
          </div>
          <div class="right">
            <div class="delNote-date">{{ deliveryNote.formattedDeliveryNoteDate }}</div>
          </div>
        </a>
        <p v-if="!deliveryNotes.length" class="no-result">
          {{ $t('deliveryNotes.no_matching_delivery_note') }}
        </p>
      </div>
    </div>
    <div class="delivery-note-view-page-container">
      <iframe :src="`${shareableLink}`" class="frame-style"/>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
const _ = require('lodash')

export default {
  data () {
    return {
      id: null,
      count: null,
      deliveryNotes: [],
      deliveryNote: null,
      currency: null,
      searchData: {
        orderBy: null,
        orderByField: null,
        searchText: null
      },
      status: ['DRAFT', 'SENT', 'VIEWED', 'EXPIRED', 'ACCEPTED', 'REJECTED','SETTLED'],
      isMarkAsSent: false,
      isSendingEmail: false,
      isRequestOnGoing: false,
      isSearching: false,
      userType:null
    }
  },
  computed: {
    ...mapGetters('po', [
      'POForDeliveryNotes'
    ]),
    getOrderBy () {
      if (this.searchData.orderBy === 'asc' || this.searchData.orderBy == null) {
        return true
      }
      return false
    },
    getOrderName () {
      if (this.getOrderBy) {
        return this.$t('general.ascending')
      }
      return this.$t('general.descending')
    },
    shareableLink () {
      return `/deliveryNotes/pdf/${this.deliveryNote.unique_hash}`
    }
  },
  watch: {
    $route (to, from) {
      this.loadDeliveryNote()
    }
  },
  created () {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';      
    }
    this.loaddeliveryNotes()
    this.loadDeliveryNote()
    this.onSearched = _.debounce(this.onSearched, 500)
  },
  methods: {
     ...mapActions('deliveryNote', [
      'fetchDeliveryNotes',
      'searchDeliveryNote',
      'fetchViewDeliveryNote'
    ]),
    async loaddeliveryNotes () {
        let response = await this.fetchDeliveryNotes({ purchase_order_id:this.POForDeliveryNotes})
      
        if (response.data) {
            this.deliveryNotes = response.data.deliveryNotes.data
        }
    },
    async loadDeliveryNote () {
      let response = await this.fetchViewDeliveryNote(this.$route.params.id)

      if (response.data) {
        this.deliveryNote = response.data.deliveryNote
      }
    },
    async onSearched () {
      let data = ''
      if (this.searchData.searchText !== '' && this.searchData.searchText !== null && this.searchData.searchText !== undefined) {
        data += `search=${this.searchData.searchText}&`
      }

      if (this.searchData.orderBy !== null && this.searchData.orderBy !== undefined) {
        data += `orderBy=${this.searchData.orderBy}&`
      }

      if (this.searchData.orderByField !== null && this.searchData.orderByField !== undefined) {
        data += `orderByField=${this.searchData.orderByField}`
      }
      
      this.isSearching = true
      let response = await this.searchDeliveryNote(data)
      this.isSearching = false
      if (response.data) {
        this.deliveryNotes = response.data.deliveryNotes.data
      }
    },
    sortData () {
      if (this.searchData.orderBy === 'asc') {
        this.searchData.orderBy = 'desc'
        this.onSearched()
        return true
      }
      this.searchData.orderBy = 'asc'
      this.onSearched()
      return true
    },
    viewDeliveryNote(id){
        this.$router.push(`/supplier/delivery-notes/${id}/view`)
    }
  }
}
</script>
